import { ConfigService } from '@abovo/shared-angular-utils';

/**
 * Resolves the Matomo site id for the hostname the application is currently served under.
 *
 * The `MATOMO_SITE_IDS` environment variable holds a comma separated hostname/id mapping, e.g. `media.vision=2,webvis-v2.abovo.nl=1`.
 * A hostname matches exactly or as a subdomain, so `media.vision=2` also covers `www.media.vision`.
 *
 * Returns `null` when the current hostname is not mapped, meaning that host is not tracked.
 */
export const resolveMatomoConfig = (configService: ConfigService) => {
   const siteIdsByHost: string = configService.get('app.matomo_site_ids') ?? '';
   const trackerUrl: string = configService.get('app.matomo_tracker_url');
   const hostname = window.location.hostname;

   const matchedEntry = siteIdsByHost
      .split(',')
      .map((entry) => entry.split('='))
      .find(([host]) => {
         const configuredHost = host.trim();
         return hostname.endsWith(configuredHost);
      });

   const siteId = Number(matchedEntry?.[1]?.trim());
   if (Number.isInteger(siteId) && siteId > 0) {
      return { siteId, trackerUrl };
   }
   return null;
};
